import { render, staticRenderFns } from "./BarcodeAddNew.vue?vue&type=template&id=b928db2e&scoped=true&"
import script from "./BarcodeAddNew.vue?vue&type=script&lang=js&"
export * from "./BarcodeAddNew.vue?vue&type=script&lang=js&"
import style0 from "./BarcodeAddNew.vue?vue&type=style&index=0&id=b928db2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b928db2e",
  null
  
)

export default component.exports